(function () {
  // --- Utilities ---
  function nowMs() { return Date.now ? Date.now() : new Date().getTime(); }

  function ensureHidden(form, name, id) {
    var el = form.querySelector('#' + id + ', input[name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.id = id;
      el.value = '';
      form.appendChild(el);
    }
    return el;
  }

  function initTs(tsField) {
    if (!tsField.value) tsField.value = String(nowMs());
  }

  function safeRequestSubmit(form) {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  // --- Get GA4 client_id from cookie ---
  function getGaClientId() {
    try {
      var gaCookie = document.cookie
        .split('; ')
        .find(function(row) { return row.startsWith('_ga='); });
      if (gaCookie) {
        var parts = gaCookie.split('=')[1].split('.');
        return parts.slice(-2).join('.');
      }
    } catch(e) {}
    return '555.555';
  }

  // --- Report bot to Worker silently (GA4 logging only) ---
  function reportBot(botSignal) {
    var fd = new FormData();
    fd.append('website', botSignal === 'text_field' ? 'triggered' : '');
    fd.append('agree_terms', botSignal === 'checkbox' ? 'on' : '');
    fd.append('ga_client_id', getGaClientId());

    fetch('https://form-guard.randy-torres.workers.dev', {
      method: 'POST',
      body: fd
    }).then(function() {
      console.log('Bot reported to Worker successfully');
    }).catch(function(err) {
      console.warn('Worker report failed:', err);
    });
  }

  // --- Core binding ---
  function bindForm(form) {
    if (form.__botGuardBound) return;
    form.__botGuardBound = true;

    var tsField = ensureHidden(form, 'hp_init_ts', 'hp_init_ts');
    var tokenField = ensureHidden(form, 'hp_delay_ok', 'hp_delay_ok');
    initTs(tsField);

    // Add GA4 client_id hidden field
    var gaField = ensureHidden(form, 'ga_client_id', 'ga_client_id');
    gaField.value = getGaClientId();

    // NOTE: form.action intentionally NOT overridden — Shopify handles natively

    // Honeypot text field
    var hpText = form.querySelector('#hp_website, input[name="website"]');
    if (!hpText) {
      hpText = document.createElement('input');
      hpText.type = 'text';
      hpText.name = 'website';
      hpText.id = 'hp_website';
      hpText.autocomplete = 'off';
      hpText.tabIndex = -1;
      hpText.setAttribute('aria-hidden', 'true');
      hpText.style.position = 'absolute';
      hpText.style.left = '-9999px';
      hpText.style.top = 'auto';
      hpText.style.width = '1px';
      hpText.style.height = '1px';
      hpText.style.overflow = 'hidden';
      form.appendChild(hpText);
    }

    // Honeypot checkbox
    var hpCheck = form.querySelector('#hp_agree_terms, input[name="agree_terms"]');
    if (!hpCheck) {
      hpCheck = document.createElement('input');
      hpCheck.type = 'checkbox';
      hpCheck.name = 'agree_terms';
      hpCheck.id = 'hp_agree_terms';
      hpCheck.tabIndex = -1;
      hpCheck.setAttribute('aria-hidden', 'true');
      hpCheck.style.position = 'absolute';
      hpCheck.style.left = '-9999px';
      hpCheck.style.top = 'auto';
      hpCheck.style.width = '1px';
      hpCheck.style.height = '1px';
      hpCheck.style.overflow = 'hidden';
      form.appendChild(hpCheck);
    }

    // Timestamp realism
    var userStarted = false;
    ['input', 'change', 'focus', 'click', 'keydown', 'paste'].forEach(function (evt) {
      form.addEventListener(evt, function () {
        if (!userStarted) {
          userStarted = true;
          initTs(tsField);
        }
      }, { once: true, capture: true });
    });

    var delaying = false;

    form.addEventListener('submit', function (e) {
      var hpTextTriggered = hpText && hpText.value && hpText.value.trim() !== '';
      var hpCheckTriggered = hpCheck && hpCheck.checked === true;

      // Honeypot triggered — block and report to Worker for GA4 logging
      if (hpTextTriggered || hpCheckTriggered) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        reportBot(hpTextTriggered ? 'text_field' : 'checkbox');

        console.log('Bot blocked and reported');
        return false;
      }

      if (tokenField.value === '1') return;
      if (!form.checkValidity()) return;

      e.preventDefault();
      if (delaying) return;
      delaying = true;

      var baseDelay = 300 + Math.floor(Math.random() * 200);
      var minHuman = 800;

      var started = Number(tsField.value || nowMs());
      var elapsed = nowMs() - started;

      var delay = baseDelay;
      if (elapsed < minHuman) delay += (minHuman - elapsed);

      window.setTimeout(function () {
        tokenField.value = '1';
        safeRequestSubmit(form);
      }, delay);
    }, true);
  }

  // --- Init & rebind ---
  function init() {
    var forms = document.querySelectorAll([
      'form[action*="/contact"]',
      'form#ContactForm',
      'form[name="contact"]',
      '#shopify-section-static-contact-page form',
      'section[id^="shopify-section-static-contact"] form',
      'section[id*="static-contact"] form'
    ].join(', '));

    if (!forms.length) return;
    forms.forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
